var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-login"},[_c('img',{staticClass:"logo-black",attrs:{"src":require("@/core/assets/img/marketea_logo_2023_blue.svg"),"alt":"logo"},on:{"click":_vm.backWebsite}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('h2',{staticClass:"titulo"},[_vm._v("Marketea; Your Marketing, Web Presence & Technology Solution")])])
}]

export { render, staticRenderFns }